import { useDispatch } from 'react-redux';
import { Dispatch } from 'redux';
import { useCallback, useEffect } from 'react';

import { RootActions } from 'CorePackage/MainModule/types/RootActions';

import { IDecisionForm } from '../interfaces/IDecisionForm';
import {
  decisionSetErknmKnmKindVersionIdFormValue,
  decisionSetErknmKnoOrganizationFormValue,
  decisionSetErknmSupervisionTypeFormValue,
  decisionSetReasonFormValue,
} from '../actions/decisionActions';

export function useDecision(values: IDecisionForm) {
  const dispatch = useDispatch<Dispatch<RootActions>>();
  const formKnoOrganization = values.knoOrganization;
  const formSupervisionType = values.kindControl;
  const formKind = values.kind;
  const formReasons = values.reasons;

  const setKnoOrganizationFormValue = useCallback(
    () => dispatch(decisionSetErknmKnoOrganizationFormValue(formKnoOrganization)),
    [dispatch, formKnoOrganization],
  );

  useEffect(() => {
    setKnoOrganizationFormValue();
  }, [setKnoOrganizationFormValue]);

  const setSupervisionTypeFormValue = useCallback(
    () => dispatch(decisionSetErknmSupervisionTypeFormValue(formSupervisionType)),
    [dispatch, formSupervisionType],
  );

  const setDecisionKindFormValue = useCallback(
    () => dispatch(decisionSetErknmKnmKindVersionIdFormValue(formKind?.value.dictVersionId)),
    [dispatch, formKind],
  );

  const setReasonsFormValue = useCallback(() => {
    dispatch(decisionSetReasonFormValue(formReasons));
  }, [dispatch, formReasons]);

  useEffect(() => {
    setDecisionKindFormValue();
  }, [setDecisionKindFormValue]);

  useEffect(() => {
    setSupervisionTypeFormValue();
  }, [setSupervisionTypeFormValue]);

  useEffect(() => {
    setReasonsFormValue();
  }, [setReasonsFormValue]);
}
